
export class WellsProjectAssetMapping {
  WellId: number;
  Ssn: string;
  Name: string;
  OWID: string;
  PadId: number | null;
  ScenarioId: number;
  AssetId: number;
  AssetName: string | null;
  AssetTeamId: number | null;
  TankBatteryAreaId: number | null;
  IsInsideCityLimits: boolean | null;
  CountyId: number | null;
  County: string | null;
  StateId: string | null;
  State: string | null;
  AssetTypeId: number;
  AssetType: string;
  AssetSuperTypeId: number;
  AssetSuperType: string;
  CostCenterId: number | null;
  CostCenterNumber: number | null;
  CostCenter: string | null;
  TypeCurveAreaId: number | null;
  TypeCurveArea: string | null;
  ActualGrossWorkingInterest: number | null;
  EstimatedNetWorkingInterest: number | null;
  PreliminaryNetWorkingInterest: number | null;
  TargetFormation: string | null;
  ProjectIds: string;
  ProjectTypes: string;

  constructor(item?: IWellsProjectAssetMappingView) {
    if (item) {

      this.WellId = item.WellId;
      this.Ssn = item.Ssn;
      this.Name = item.Name;
      this.OWID = item.OWID ? item.OWID : '';
      this.PadId = item.PadId;
      this.ScenarioId = item.ScenarioId;
      this.AssetId = item.AssetId;
      this.AssetName = item.AssetName;
      this.AssetTeamId = item.AssetTeamId;
      this.TankBatteryAreaId = item.TankBatteryAreaId;
      this.IsInsideCityLimits = item.IsInsideCityLimits;
      this.CountyId = item.CountyId;
      this.County = item.County;
      this.StateId = item.StateId;
      this.State = item.State;
      this.AssetTypeId = item.AssetTypeId;
      this.AssetType = item.AssetType;
      this.AssetSuperTypeId = item.AssetSuperTypeId;
      this.AssetSuperType = item.AssetSuperType;
      this.CostCenterId = item.CostCenterId;
      this.CostCenterNumber = item.CostCenterNumber;
      this.CostCenter = item.CostCenter;
      this.TypeCurveAreaId = item.TypeCurveAreaId;
      this.TypeCurveArea = item.TypeCurveArea;
      this.ActualGrossWorkingInterest = item.ActualGrossWorkingInterest;
      this.EstimatedNetWorkingInterest = item.EstimatedNetWorkingInterest;
      this.PreliminaryNetWorkingInterest = item.PreliminaryNetWorkingInterest;
      this.TargetFormation = item.TargetFormation;
      this.ProjectIds = item.ProjectIds;
      this.ProjectTypes = item.ProjectTypes;

    }
  }
}

export interface IWellsProjectAssetMappingView {
  WellId: number;
  Ssn: string;
  Name: string;
  OWID: string;
  PadId: number | null;
  ScenarioId: number;
  AssetId: number;
  AssetName: string | null;
  AssetTeamId: number | null;
  TankBatteryAreaId: number | null;
  IsInsideCityLimits: boolean | null;
  CountyId: number | null;
  County: string | null;
  StateId: string | null;
  State: string | null;
  AssetTypeId: number;
  AssetType: string;
  AssetSuperTypeId: number;
  AssetSuperType: string;
  CostCenterId: number | null;
  CostCenterNumber: number | null;
  CostCenter: string | null;
  TypeCurveAreaId: number | null;
  TypeCurveArea: string | null;
  ActualGrossWorkingInterest: number | null;
  EstimatedNetWorkingInterest: number | null;
  PreliminaryNetWorkingInterest: number | null;
  TargetFormation: string | null;
  ProjectIds: string;
  ProjectTypes: string;
}